import { useEffect } from "react";

interface Props {
  children: React.ReactNode;
}

export default function ModalWrapper({ children }: Props) {
  useEffect(() => {
    const element = document.querySelector(".builder-header") as HTMLDivElement;
    if (element) element.style.zIndex = "97";

    return () => {
      if (element) element.style.zIndex = "99";
    };
  }, []);

  return children;
}
